import { useForm } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import { Box, HStack, Text, Checkbox } from '@chakra-ui/react'
import { useState } from 'react'
import { components } from 'react-select'

import { t } from '@/lib/helpers'
import { Select } from '@/components/Select'
import { DatePicker, DateType } from '@/components/DatePicker'
import { useFilterContext } from '@/features/filters/context'
import { useAdminCompanies, useAdminProjectOptions } from '@/features/admins/page_views/hooks/useAdminPageViewsApi'
import AdminPageViewCsvDownload from '../AdminPageViewCsvDownload/AdminPageViewCsvDownload'

const Option = (props: any) => (
  <components.Option {...props}>
    <HStack alignContent="center" spacing="6px">
      <Checkbox isChecked={props.isSelected} />
      <Text fontSize="14px">{props.label}</Text>
    </HStack>
  </components.Option>
);

function AdminPageViewFilterSection() {
  const { control } = useForm();

  const [dateRange, setDateRange] = useState<DateType[]>([null, null])
  const [startDate, endDate] = dateRange

  const { meta, setFilter } = useFilterContext()
  const companyId = meta.company_id as number | null

  const { data: companiesData, isLoading: isLoadingCompanies } = useAdminCompanies()
  const companyOptions = companiesData ?? []

  const { data: projectsData, isLoading: isLoadingProjects } = useAdminProjectOptions(companyId)
  const projectOptions = projectsData?.project_options ?? []

  const onCalendarChange = (dates: DateType[]) => {
    setDateRange(dates)
    setFilter('start_date', dates[0]?.toDateString())
    setFilter('end_date', dates[1]?.toDateString())
  }

  return (
    <HStack align="flex-end" justifyContent="space-between">
      <HStack align="flex-end" spacing="14px">
        <Box width="340px">
          <Text fontWeight="500" pb="6px">Company</Text>
          <Select
            placeholder="Select a company"
            options={companyOptions}
            isLoading={isLoadingCompanies}
            onChange={(option: { value: number }) => {
              setFilter('company_id', option.value)
              setFilter('url', [])
            }}
          />
        </Box>

        <Box width="340px">
          <Text fontWeight="500" pb="6px">Domain</Text>
          <Controller name="url" control={control} render={() => (
            <Select
              placeholder="Select domain(s)"
              options={projectOptions}
              isLoading={isLoadingProjects}
              isDisabled={!companyId || isLoadingProjects}
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              onChange={(values: any[]) => setFilter('url', values.map(v => v.value))}
              value={projectOptions.filter((opt: any) => meta.url?.includes(opt.value))}
              components={{ Option }}
            />
          )} />
        </Box>

        <Box width="250px">
          <Text fontWeight="500" pb="6px">Date Range</Text>
          <Controller name="date_range" control={control} render={() => (
            <DatePicker startDate={startDate} endDate={endDate} onChange={onCalendarChange} />
          )} />
        </Box>
      </HStack>
      <AdminPageViewCsvDownload />
    </HStack>
  )
}

export default AdminPageViewFilterSection;
